import cn from 'classnames';
import * as React from 'react';

import * as styles from './Phones.css';

interface IPhone {
  link: string;
  number: string;
}

export interface IPhonesProps {
  phones: IPhone[];
  size?: 'xs' | 's' | 'm';
}

export function Phones({ phones, size = 'm' }: IPhonesProps) {
  return (
    <div>
      {phones.map((phone, index) => (
        <a key={index} href={phone.link} className={cn(styles['phone'], styles[`phone-size-${size}`])}>
          {phone.number}
        </a>
      ))}
    </div>
  );
}
